import axios, { AxiosResponse } from 'axios';
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Container } from 'reactstrap';
import { Dimmer, Form, Loader, Message } from "semantic-ui-react";
import { config } from "../../contexts/UrlContext";
import UploadLicenseDropzone from "./UploadLicenseDropzone";
import Footer from '../Layout/Footer';
import NavMenuBasic from "../Layout/NavMenuBasic";
import AuthContext from '../../contexts/AuthContext';
import { getRequest } from '../../services/axiosService';


function LicenseError() {

    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false)

    const { auth } = useContext(AuthContext);


    useEffect(() => {
        async function check() {
            await checkAdmin();
        }
        check();
    }, []);

    const checkAdmin = async () => {

        try {
            let response: AxiosResponse = await getRequest(auth, `/ContentManager/CheckAdmin`);
            setIsAdmin(response.data);
        } catch (error) {
            toast.error("error checking admin access");
            setIsAdmin(false);
            console.log(error);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading CM2WebShare...</Loader>
            </Dimmer>
          );
    } else {
        return (
            <div className="app">
                <NavMenuBasic />
                <div className="site-content" id="license-error-content">
                <Container id="license-error" style={{ height: "100%", width: "100%" }}>
                    {isAdmin === true && 
                      <Form className="ui form" >
                        <div className="header blue " style={{ color: "#5D7BB0", marginLeft: 10, marginTop: 5, marginBottom: 5 }} >License Error</div>
                        <div className="meta" style={{marginLeft: 10}}>The license file does not exist or has expired. If you have an updated license you can upload it using the section below, if not please contact <b>membershub@fyb.com.au</b> for more information.</div>
                        <div className="header gray " style={{ color: "#5f5b58", marginLeft: 10, marginTop: 10, marginBottom: 5 }} >UPLOAD LICENSE</div>
                        <div className="meta" style={{marginLeft: 10, marginBottom: 5}}>Upload your new license below</div>
                        <UploadLicenseDropzone style={{marginLeft: 10}} />
                    </Form>
                    }
                    {!isAdmin &&
                        <Message icon='exclamation triangle' header='License is invalid' content='You are not licensed to use this product. Please contact FYB at membershub@fyb.com.au.' />
                    }
                </Container>
                </div>
                <div className="site-footer">
                    <Footer/>
                </div>
            </div>
        );
    }
}

export default LicenseError;